import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, Smartphone } from 'lucide-react';
import { VERIFICATION_TYPES, canDo, nextStep, stepLink, stepsFor } from '@/utils/verifications';
import '@/styles/verification.css';

/**
 * Carte du tableau de bord tant que le compte ne peut pas publier : progression et prochaine étape, pour que
 * l'utilisateur sache où il en est avant de cliquer. Un compte qui n'a plus que le numéro à confirmer (le jour où la
 * vérification du téléphone s'ouvre) voit « Une nouvelle étape ».
 */
export default function ProfileProgressCard({ user, from = '/app/dashboard' }) {
  if (!user || canDo(user, 'publish')) return null;
  const steps = stepsFor(user, 'publish');
  const next = nextStep(steps);
  const rest = steps.filter((s) => s.state !== 'VERIFIED');
  const done = steps.length - rest.length;
  const pct = steps.length ? Math.round((done / steps.length) * 100) : 0;
  const onlyPhone = rest.length === 1 && rest[0].kind === 'phone' && done > 0;

  if (onlyPhone) {
    return (
      <div className="vg vg-card" data-testid="profile-progress" data-kind="new-phone">
        <span className="vg-card-icon"><Smartphone size={22} aria-hidden="true" /></span>
        <div className="vg-card-body">
          <div className="vg-card-title">Une nouvelle étape : confirmez votre numéro</div>
          <div className="vg-card-text">1 minute, par WhatsApp ou SMS. Nécessaire pour continuer à publier et proposer.</div>
        </div>
        <Link to={stepLink('phone', from)} className="vg-btn vg-btn--primary" data-testid="profile-progress-cta">Confirmer</Link>
      </div>
    );
  }

  const restLabel = rest.map((s) => (VERIFICATION_TYPES[s.kind]?.label || s.kind).toLowerCase()).join(', ');
  return (
    <div className="vg vg-card" data-testid="profile-progress">
      {next ? (
        <span className="vg-ring" style={{ '--p': pct }}><span>{pct} %</span></span>
      ) : (
        <span className="vg-card-icon"><Clock size={22} aria-hidden="true" /></span>
      )}
      <div className="vg-card-body">
        <div className="vg-card-title">{next ? 'Complétez votre profil pour publier' : 'Votre identité est en cours de vérification'}</div>
        <div className="vg-card-text">
          {next ? `${done} étape${done > 1 ? 's' : ''} sur ${steps.length} · reste : ${restLabel}`
            : 'Réponse sous 24 h, par e-mail. Vous pourrez ensuite publier et proposer.'}
        </div>
      </div>
      {next && (
        <Link to={stepLink(next.kind, from)} className="vg-btn vg-btn--primary" data-testid="profile-progress-cta">Continuer</Link>
      )}
    </div>
  );
}
